import React from 'react';
import { closeModal, openModal } from '../../api/modals/actions';
import { flagSong } from '../../api/song/actions';
import { store } from '../../store';
import { connectWithStore } from '../../utils';
import GuitarpartyModal from '../modal';

const FLAG_OPTIONS = [
    ['wrong_lyrics', gettext('Wrong lyrics')],
    ['missing_lyrics', gettext('Missing lyrics')],
    ['wrong_chord', gettext('Wrong chord')],
    ['missing_chord', gettext('Missing chord')],
    ['author_wrong_or_missing', gettext('Author wrong/missing')],
    ['chords_outside_lyrics', gettext('Chords outside of lyrics')],
    ['missing_solo', gettext('Missing solo')],
]

class FlagSong extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            wrong_lyrics: false,
            missing_lyrics: false,
            wrong_chord: false,
            missing_chord: false,
            author_wrong_or_missing: false,
            chords_outside_lyrics: false,
            missing_solo: false,
            explanation: '',
            isSubmitting: false,
            isSubmitted: false,
            error: null,
        }
    }

    getModalKey() {
        return `modal-flag-song-${this.props.songId}`
    }

    openModal() {
        this.setState({ isSubmitted: false, error: null })
        this.props.dispatch(openModal(this.getModalKey()))
    }

    closeModal() {
        this.props.dispatch(closeModal(this.getModalKey()))
    }

    hasSelectedFlag() {
        return FLAG_OPTIONS.some(([key]) => this.state[key])
    }

    onCheckboxChange(key, event) {
        this.setState({ [key]: event.target.checked })
    }

    onExplanationChange(event) {
        this.setState({ explanation: event.target.value })
    }

    submitFlag(event) {
        event.preventDefault()
        if (!this.hasSelectedFlag() || this.state.isSubmitting) {
            return
        }

        const data = FLAG_OPTIONS.reduce((acc, [key]) => {
            acc[key] = this.state[key]
            return acc
        }, {
            explanation: this.state.explanation,
        })

        this.setState({ isSubmitting: true, error: null })
        Promise.resolve(this.props.dispatch(flagSong(this.props.songId, data)))
            .then(() => {
                this.setState({
                    wrong_lyrics: false,
                    missing_lyrics: false,
                    wrong_chord: false,
                    missing_chord: false,
                    author_wrong_or_missing: false,
                    chords_outside_lyrics: false,
                    missing_solo: false,
                    explanation: '',
                    isSubmitting: false,
                    isSubmitted: true,
                    error: null,
                })
            })
            .catch((error) => {
                const errorMessage = error && error.status === 429
                    ? gettext('Too many reports. Please try again later.')
                    : gettext('Unable to submit correction. Please try again.')
                this.setState({
                    isSubmitting: false,
                    error: errorMessage,
                })
            })
    }

    render() {
        return (
            <div className="flag-song">
                <button className="btn btn-icon-after" onClick={this.openModal.bind(this)}><span>{gettext('Report error')}</span></button>
                <GuitarpartyModal extraClasses="modal-flag-song" modalKey={this.getModalKey()} {...this.props}>
                    <button type="button" className="close" data-dismiss="modal" aria-label={gettext('Close')} onClick={this.closeModal.bind(this)}>
                        <span></span>
                        <span></span>
                    </button>
                    <div className="modal-body">
                        <h5 className="modal-title">{gettext('Flag song error')}</h5>
                        {this.state.isSubmitted ?
                            <p>{gettext('Thank you. Your correction has been submitted.')}</p>
                            :
                            <form onSubmit={this.submitFlag.bind(this)}>
                                {this.state.error &&
                                    <p className="alert alert-danger">{this.state.error}</p>
                                }
                                <div className="flag-song-options">
                                    {FLAG_OPTIONS.map(([key, label]) => (
                                        <label key={key} className="flag-song-option">
                                            <input type="checkbox" checked={this.state[key]} onChange={this.onCheckboxChange.bind(this, key)} />
                                            <span>{label}</span>
                                        </label>
                                    ))}
                                </div>
                                <div className="flag-song-explanation">
                                    <label htmlFor={`flag-song-explanation-${this.props.songId}`}>{gettext('Explanation')}</label>
                                    <textarea
                                        id={`flag-song-explanation-${this.props.songId}`}
                                        value={this.state.explanation}
                                        onChange={this.onExplanationChange.bind(this)}
                                    />
                                </div>
                                <div className="modal-footer flag-song-actions">
                                    <button type="button" className="btn flag-song-secondary" onClick={this.closeModal.bind(this)}>{gettext('Close')}</button>
                                    <button type="submit" className="btn flag-song-primary" disabled={!this.hasSelectedFlag() || this.state.isSubmitting}>{gettext('Submit')}</button>
                                </div>
                            </form>
                        }
                    </div>
                </GuitarpartyModal>
            </div>
        )
    }
}

export default connectWithStore(store, FlagSong);
